import { useMutation } from '@gogame/query';

import { loadInternalError500Long } from 'scenes/Playground/sources/playground';

import { internalError500Long } from '../queryKeyFactory';

export const useInternalError500Long = () => {
  const approveMutation = useMutation(
    internalError500Long(),
    loadInternalError500Long,
    {
      successMessage: () => `internalError500Long success`,
      refresh: false,
    }
  );

  return [approveMutation.mutateAsync, approveMutation];
};
